// Site bilgileri - ChatBot için context
export const getSiteContext = (language: 'tr' | 'en'): string => {
  const isTR = language === 'tr';
  
  return isTR ? `
FURKAN GÜL - KİŞİSEL BİLGİLER VE CV

KİŞİSEL BİLGİLER:
- İsim: Furkan Gül
- Konum: İstanbul, Türkiye
- Rol: Full Stack Developer & DevOps Engineer
- Email: furkan@furkangul.net
- Telefon: +90 507 584 77 22
- GitHub: https://github.com/furkan1287
- LinkedIn: https://www.linkedin.com/in/furkan1287/

DİL BİLGİSİ:
- Türkçe: Ana Dil (C2)
- İngilizce: Bağımsız Kullanıcı (B2)
- Rusça: Temel Kullanıcı (A1)

BECERİLER:
Backend: C#, .NET, ASP.NET, ASP.NET Core, Entity Framework, Entity Framework Core, Dapper, ADO.NET, SQL Server, PostgreSQL, MongoDB, RESTful API, Microservices, Docker, Git, GitHub
Java: Java, Java OOP, Spring, Spring Boot, JPA, Spring Security, Spring Web MVC, Hibernate
Frontend: React, React.js, ReactJs, React Hooks, Redux, JavaScript, TypeScript, HTML5, CSS, CSS3, SCSS, CSS Preprocessors, Component-Based Development, DOM, Ajax
Diğer: Dependency Injection, SOLID Principles, OOP, Clean Architecture, Layered Architecture, Unit Testing, Integration Testing, xUnit, Moq, Swagger, Identity, Node.js, AWS, Linux, Azure

DENEYİMLER:

1. FREELANCE FULL STACK DEVELOPER (Ocak 2024 - Devam Ediyor)
- 19 Ocak 2024'ten beri freelance olarak çalışıyorum
- Çeşitli projelerde full stack geliştirme hizmetleri sunuyorum
- Müşteri odaklı çözümler üretiyorum

2. SİSTEM NETWORK UZMAN YARDIMCISI - BİLGİ SİSTEMLERİ (Mart 2024 - Eylül 2024, İstanbul, Türkiye)
- Linux tabanlı sistemlerin kurulumu ve yönetimi
- Azure, AWS ve Microsoft teknolojileri üzerinde bulut çözümleri
- DevOps süreçlerinde otomasyon, sistem optimizasyonu ve sürdürülebilirlik
- Database management, Zabbix ile izleme, firewall ve switch yapılandırmaları
- Help Desk desteği, kullanıcı sorunlarının çözümü ve teknik destek

3. FULL STACK DEVELOPER - TECH CAREER FULLSTACK BOOTCAMP (Aralık 2023 - Ocak 2024, İstanbul, Türkiye)
- .NET Core ile backend ve React.js ile frontend geliştirme
- Bitirme projesi: .NET & React.js tabanlı bilet alma sitesi
- Kullanıcı kayıt/giriş, etkinlik listeleri, bilet satın alma ve ödeme akışı
- RESTful API yapısı, veri yönetimi ve kullanıcı doğrulama

4. FULL STACK DEVELOPER - FMSS (Haziran 2022 - Eylül 2022, İstanbul, Türkiye)
- Java Spring Boot (backend) ve React.js (frontend) teknolojileri
- Temiz kod prensipleri (Clean Code) ve SDLC uygulamaları
- PostgreSQL veritabanı üzerinde veri modelleme ve sorgulama
- Git versiyon kontrolü, branch yönetimi ve ekip içi iş birliği

EĞİTİM:

1. ADANA ALPARSLAN TÜRKEŞ BİLİM VE TEKNOLOJİSİ ÜNİVERSİTESİ (2017 - 2023)
- Bölüm: Bilgisayar Mühendisliği
- Derece: Lisans
- Website: www.atu.edu.tr

2. İSTANBUL TİCARET ODASI - SOFTİTO BACKEND BOOTCAMP (2025)
- Başarı: Birincilik 🏆 (320 Saat)
- Eğitim Konuları: C# .NET, ASP.NET Core, Entity Framework Core, SQL Server, RESTful API geliştirme, Katmanlı Mimari, Clean Architecture, Identity ile kullanıcı yönetimi, Docker, Git/GitHub, mikroservis temelleri

SOSYAL GÖNÜLLÜLÜKLER:

1. AFAD GÖNÜLLÜSÜ (2021 - Devam Ediyor)
- 2021'den beri AFAD gönüllüsü olarak görev alıyorum
- Acil durum müdahalelerinde destek sağlıyorum

2. AIESEC ADANA - IGV DEPARTMANI LİDERİ (2021)
- Incoming Global Volunteer departmanında liderlik yaptım
- Yurtdışından gelen gönüllüleri yönettim ve koordinasyon sağladım
- İngilizce iletişim becerilerimi aktif olarak kullandım
- Kriz yönetimi ve problem çözme konularında deneyim kazandım

3. WORK AND TRAVEL PROGRAM (2021 - 4 Ay)
- 4 aylık Work and Travel programında yurtdışında çalışma deneyimi kazandım
- Farklı kültürlerle çalışma ve iletişim kurma becerilerimi geliştirdim
- İngilizce dil becerilerimi pratikte kullanma fırsatı buldum

PROJELER:
GitHub'da çeşitli projeler bulunmaktadır. Freelance projeler: Pastacı Hamdi, Pace, Webspider, Sisore Restaurant, Bijusaray, Payitaht İnşaat, Eloboost gibi production projeleri geliştirdim.

KİŞİLİK ANALİZİ:
Furkan'ın detaylı kişilik envanteri raporu mevcuttur. Bu rapor, işverenlerin Furkan'ın kişilik özelliklerini, çalışma tarzını, liderlik becerilerini ve takım çalışmasına yaklaşımını anlamalarına yardımcı olur. Rapor, 3. dönem kişilik analizi testi sonuçlarını içermektedir.

UYGUN POZİSYONLAR VE SEKTÖRLER:

POZİSYONLAR:
- Backend Developer (Öncelikli)
- Full Stack Developer
- .NET Developer / .NET Core Developer
- API Developer / RESTful API Developer
- DevOps Engineer
- System Administrator
- Technical Lead / Team Lead
- Software Architect (junior-mid level)

SEKTÖR UYGUNLUKLARI:
1. FİNTECH / FİNANS SEKTÖRÜ:
   - .NET ve güvenlik odaklı backend geliştirme
   - RESTful API ve mikroservis mimarisi
   - SQL Server ve PostgreSQL veritabanı yönetimi
   - Güvenli ve ölçeklenebilir sistemler

2. E-TİCARET / RETAIL:
   - Full stack e-ticaret platformları (Pastacı Hamdi, Bijusaray gibi production projeler)
   - Ödeme entegrasyonları ve güvenli işlem yönetimi
   - React.js ile modern kullanıcı arayüzleri
   - Admin paneli geliştirme deneyimi

3. SAAS / ENTERPRISE YAZILIM:
   - Microservices mimarisi ve Clean Architecture
   - Docker containerization
   - DevOps süreçleri (Azure, AWS)
   - Ölçeklenebilir sistem tasarımı

4. STARTUP / HIZLI BÜYÜYEN ŞİRKETLER:
   - Freelance deneyimi ile hızlı adaptasyon
   - Çok yönlü beceriler (frontend + backend + DevOps)
   - Bağımsız çalışma ve proje yönetimi
   - Müşteri odaklı çözüm üretme

5. KURUMSAL / BÜYÜK ŞİRKETLER:
   - SOLID prensipleri ve temiz kod yazma
   - Unit testing ve integration testing
   - Git/GitHub ile versiyon kontrolü
   - Takım çalışması ve liderlik deneyimi (AIESEC, AFAD)

ÖNE ÇIKAN ÖZELLİKLER:
- SOFTİTO Backend Bootcamp Birinciliği (320 saat, 2025) 🏆
- 7+ production projesi (Pastacı Hamdi, Pace, Webspider, Sisore, Bijusaray, Payitaht, Eloboost)
- Freelance başarısı (Ocak 2024'ten beri)
- Liderlik deneyimi (AIESEC IGV Departmanı Lideri, 2021)
- Kriz yönetimi ve problem çözme becerileri
- İngilizce iletişim (B2 seviyesi)
- Çok kültürlü takım çalışması deneyimi (Work and Travel, AIESEC)
` : `
FURKAN GUL - PERSONAL INFORMATION AND CV

PERSONAL INFORMATION:
- Name: Furkan Gül
- Location: Istanbul, Turkey
- Role: Full Stack Developer & DevOps Engineer
- Email: furkan@furkangul.net
- Phone: +90 507 584 77 22
- GitHub: https://github.com/furkan1287
- LinkedIn: https://www.linkedin.com/in/furkan1287/

LANGUAGES:
- Turkish: Native (C2)
- English: Independent User (B2)
- Russian: Basic User (A1)

SKILLS:
Backend: C#, .NET, ASP.NET, ASP.NET Core, Entity Framework, Entity Framework Core, Dapper, ADO.NET, SQL Server, PostgreSQL, MongoDB, RESTful API, Microservices, Docker, Git, GitHub
Java: Java, Java OOP, Spring, Spring Boot, JPA, Spring Security, Spring Web MVC, Hibernate
Frontend: React, React.js, ReactJs, React Hooks, Redux, JavaScript, TypeScript, HTML5, CSS, CSS3, SCSS, CSS Preprocessors, Component-Based Development, DOM, Ajax
Other: Dependency Injection, SOLID Principles, OOP, Clean Architecture, Layered Architecture, Unit Testing, Integration Testing, xUnit, Moq, Swagger, Identity, Node.js, AWS, Linux, Azure

EXPERIENCE:

1. FREELANCE FULL STACK DEVELOPER (January 2024 - Present)
- Working as a freelancer since January 19, 2024
- Providing full stack development services for various projects
- Creating customer-focused solutions

2. SYSTEM NETWORK ASSISTANT SPECIALIST - INFORMATION SYSTEMS (March 2024 - September 2024, Istanbul, Turkey)
- Installation and management of Linux-based systems
- Cloud solutions on Azure, AWS and Microsoft technologies
- Automation, system optimization and sustainability in DevOps processes
- Database management, monitoring with Zabbix, firewall and switch configurations
- Help Desk support, user problem resolution and technical support

3. FULL STACK DEVELOPER - TECH CAREER FULLSTACK BOOTCAMP (December 2023 - January 2024, Istanbul, Turkey)
- Backend development with .NET Core and frontend with React.js
- Capstone project: .NET & React.js based ticket booking site
- User registration/login, event listings, ticket purchase and payment flow
- RESTful API structure, data management and user authentication

4. FULL STACK DEVELOPER - FMSS (June 2022 - September 2022, Istanbul, Turkey)
- Java Spring Boot (backend) and React.js (frontend) technologies
- Clean Code principles and SDLC practices
- Data modeling and querying on PostgreSQL database
- Git version control, branch management and team collaboration

EDUCATION:

1. ADANA ALPARSLAN TÜRKEŞ SCIENCE AND TECHNOLOGY UNIVERSITY (2017 - 2023)
- Field: Computer Engineering
- Degree: Bachelor's Degree
- Website: www.atu.edu.tr

2. ISTANBUL CHAMBER OF COMMERCE - SOFTİTO BACKEND BOOTCAMP (2025)
- Achievement: 1st Place 🏆 (320 Hours)
- Training Topics: C# .NET, ASP.NET Core, Entity Framework Core, SQL Server, RESTful API development, Layered Architecture, Clean Architecture, Identity for user management, Docker, Git/GitHub, microservices fundamentals

SOCIAL & VOLUNTEER WORK:

1. AFAD VOLUNTEER (2021 - Present)
- Serving as an AFAD volunteer since 2021
- Providing support in emergency interventions

2. AIESEC ADANA - IGV DEPARTMENT LEADER (2021)
- Led the Incoming Global Volunteer department
- Managed and coordinated volunteers from abroad
- Actively used English communication skills
- Gained experience in crisis management and problem solving

3. WORK AND TRAVEL PROGRAM (2021 - 4 Months)
- Gained work experience abroad during a 4-month Work and Travel program
- Developed skills in working and communicating with different cultures
- Had the opportunity to use English language skills in practice

PROJECTS:
Various projects available on GitHub. Freelance projects: Developed production projects like Pastacı Hamdi, Pace, Webspider, Sisore Restaurant, Bijusaray, Payitaht Construction, Eloboost.

PERSONALITY ANALYSIS:
Furkan has a detailed personality inventory report available. This report helps employers understand Furkan's personality traits, work style, leadership skills, and approach to teamwork. The report contains results from the 3rd period personality analysis test.

SUITABLE POSITIONS AND INDUSTRIES:

POSITIONS:
- Backend Developer (Priority)
- Full Stack Developer
- .NET Developer / .NET Core Developer
- API Developer / RESTful API Developer
- DevOps Engineer
- System Administrator
- Technical Lead / Team Lead
- Software Architect (junior-mid level)

INDUSTRY SUITABILITY:
1. FINTECH / FINANCE SECTOR:
   - .NET and security-focused backend development
   - RESTful API and microservices architecture
   - SQL Server and PostgreSQL database management
   - Secure and scalable systems

2. E-COMMERCE / RETAIL:
   - Full stack e-commerce platforms (production projects like Pastacı Hamdi, Bijusaray)
   - Payment integrations and secure transaction management
   - Modern user interfaces with React.js
   - Admin panel development experience

3. SAAS / ENTERPRISE SOFTWARE:
   - Microservices architecture and Clean Architecture
   - Docker containerization
   - DevOps processes (Azure, AWS)
   - Scalable system design

4. STARTUP / FAST-GROWING COMPANIES:
   - Fast adaptation with freelance experience
   - Versatile skills (frontend + backend + DevOps)
   - Independent work and project management
   - Customer-focused solution development

5. CORPORATE / LARGE COMPANIES:
   - SOLID principles and clean code writing
   - Unit testing and integration testing
   - Version control with Git/GitHub
   - Teamwork and leadership experience (AIESEC, AFAD)

STANDOUT FEATURES:
- SOFTİTO Backend Bootcamp 1st Place (320 hours, 2025) 🏆
- 7+ production projects (Pastacı Hamdi, Pace, Webspider, Sisore, Bijusaray, Payitaht, Eloboost)
- Freelance success (since January 2024)
- Leadership experience (AIESEC IGV Department Leader, 2021)
- Crisis management and problem-solving skills
- English communication (B2 level)
- Multicultural team work experience (Work and Travel, AIESEC)
`;
};
